export default function DismissButton({ disabled, onClick }) {
  return (
    <button type="button" className="btn btn-outline-primary my-2" disabled={disabled} onClick={onClick}>
      Cancel
    </button>
  );
}
